<mat-sidenav-container>
  <mat-sidenav #sidenav mode="over" [(opened)]="sidenavOpened">
    <ng-container *ngIf="angularFireAuth.user | async;">
      <button mat-button routerLink="users">Users</button>
      <br/>
      <button mat-button routerLink="reports">📊 Reports</button>
      <br/>
      <button mat-button routerLink="coupons">🎟️ Coupons</button>
      <br/>
      <button mat-button routerLink="users-low-balance">Low Balance Notifications</button>
      <br/>
      <button mat-button routerLink="ads">Ads</button>
      <br/>
      <button mat-button routerLink="ads/duplicates">Duplicated Ads</button>
      <br/>
      <button mat-button routerLink="reviews">Reviews</button>
      <br/>
      <button mat-button routerLink="review-orders">Review Orders</button>
      <br/>
      <button mat-button routerLink="subscriptions">Subscriptions</button>
      <br/>
      <button mat-button routerLink="subscriptions/check-all">All subscriptions</button>
      <br/>
      <button mat-button [matMenuTriggerFor]="followersMenu">Followers</button>
      <mat-menu #followersMenu="matMenu">
        <button mat-menu-item routerLink="followers/following-orders">Following orders</button>
<!--        <button mat-menu-item routerLink="followers">Followers</button>-->
        <button mat-menu-item routerLink="followers/followings">Followings</button>
      </mat-menu>
      <br/>
      <!-- <button mat-button routerLink="widgets">Widgets</button>
      <br/>
      <button mat-button routerLink="impressions">Impressions</button>
      <br/>
      <button mat-button routerLink="clicks">Clicks</button>
      <br/> -->
      <button mat-button routerLink="payments">Payments</button>
      <br/>
      <button mat-button routerLink="transactions">💳 Transactions</button>
      <br/>
      <button mat-button routerLink="video-analyze-orders">AI Video Orders</button>
      <br/>
      <button mat-button routerLink="shorts">🎬 Shorts</button>
      <br/>
      <button mat-button (click)="logout()">Sign out</button>
    </ng-container>
  </mat-sidenav>

  <mat-sidenav-content>
    <header>
      <div id="navbar">
        <nav>
          <button *ngIf="angularFireAuth.user | async;" fxHide.gt-xs mat-icon-button (click)="sidenavOpened = !sidenavOpened"><mat-icon>menu</mat-icon></button>
          <button mat-button routerLink="/">
            <mat-icon>video_library</mat-icon>
            AdsVlog Admin
          </button>

          <ng-container *ngIf="angularFireAuth.user | async;">
            <button fxHide.xs mat-button routerLink="users">Users</button>
            <button fxHide.xs mat-button routerLink="reports">📊 Reports</button>
            <button fxHide.xs mat-button routerLink="coupons">🎟️ Coupons</button>
            <button fxHide.xs mat-button routerLink="users-low-balance">Low Balance Notifications</button>
            <button fxHide.xs mat-button routerLink="ads">Ads</button>
            <button fxHide.xs mat-button routerLink="ads/duplicates">Duplicated Ads</button>
            <button fxHide.xs mat-button routerLink="reviews">Reviews</button>
            <button fxHide.xs mat-button routerLink="review-orders">Review Orders</button>
            <button fxHide.xs mat-button routerLink="subscriptions">Subscriptions</button>
            <button fxHide.xs mat-button routerLink="subscriptions/check-all">All subscriptions</button>
            <button fxHide.xs mat-button [matMenuTriggerFor]="followersMenu">Followers</button>
            <mat-menu fxHide.xs #followersMenu="matMenu">
              <button mat-menu-item routerLink="followers/following-orders">Following orders</button>
<!--              <button mat-menu-item routerLink="followers">Followers</button>-->
              <button mat-menu-item routerLink="followers/followings">Followings</button>
            </mat-menu>
            <!-- <button fxHide.xs mat-button routerLink="widgets">Widgets</button>
            <button fxHide.xs mat-button routerLink="impressions">Impressions</button>
            <button fxHide.xs mat-button routerLink="clicks">Clicks</button> -->
            <button fxHide.xs mat-button routerLink="payments">Payments</button>
            <button fxHide.xs mat-button routerLink="transactions">💳 Transactions</button>
            <button fxHide.xs mat-button routerLink="video-analyze-orders">AI Video Orders</button>
            <button fxHide.xs mat-button routerLink="shorts">🎬 Shorts</button>
          </ng-container>
        </nav>
        <div fxLayout style="align-items: center; padding-right: 10px;">
          <div fxLayout style="align-items: center;" fxLayoutGap="10px" fxLayout.xs="column" *ngIf="angularFireAuth.user | async as user; else showLogin">
            <div id="account-info">
              <img *ngIf="user?.photoURL?.length" src="{{ user?.photoURL }}" id="avatar">
              <div id="user-name">{{ user.displayName }} {{ user.photoUrl }}</div>
            </div>
            <button fxHide.xs mat-button (click)="logout()">Sign out</button>
          </div>
          <ng-template #showLogin>
            <button mat-button (click)="login()">Sign in</button>
          </ng-template>
        </div>
      </div>
    </header>

    <section>
      <router-outlet></router-outlet>
    </section>

    <footer>
      <p>Copyright 2020 AdsVlog</p>
    </footer>
  </mat-sidenav-content>
</mat-sidenav-container>
